/**
 * Converts a media URL to its ImageKit CDN equivalent.
 *
 * @param {string} url - The original media URL to convert.
 * @param {string} [transform='normal'] - The ImageKit named transformation preset to apply.
 *   Built-in presets: 'normal', 'large', 'thumbnail', 'small', 'medium'.
 *   Accepts any arbitrary ImageKit preset name configured on your account.
 * @returns {string} The CDN URL with the appropriate transformation applied.
 */
export const getCDNUrl = (url, transform) => {
  const preset = (typeof transform === 'string' && transform.trim() !== '') ? transform.trim() : 'normal';

  const imageKitBase = 'https://ik.imagekit.io';
  const apiBase = 'https://api.sporthood.in';
  const wwwBase = 'https://www.sporthood.in';
  const s3Base = 'https://s3.ap-south-1.amazonaws.com/sporthood-assets/media/';

  const apiCdn = 'https://ik.imagekit.io/anehqc9js/api/tr:n-' + preset;
  const s3Cdn = 'https://ik.imagekit.io/anehqc9js/s3/tr:n-' + preset + '/';

  if (!url || url === '') {
    return 'https://ik.imagekit.io/anehqc9js/api/tr:n-normal/nophoto.png';
  }

  if (url.startsWith(imageKitBase)) {
    return url;
  }

  if (url.startsWith(s3Base)) {
    return s3Cdn + url.replace(s3Base, '');
  }

  if (url.startsWith(apiBase)) {
    return url.replace(apiBase, apiCdn);
  }

  if (url.startsWith(wwwBase) && url.includes('/assets/')) {
    return 'https://ik.imagekit.io/anehqc9js/tr:n-' + preset + url.replace(wwwBase, '');
  }

  if (url.startsWith('http')) {
    return url;
  }

  const cleanPath = url.startsWith('/') ? url.substring(1) : url;

  if (cleanPath.startsWith('static/') || cleanPath.startsWith('assets/')) {
    return 'https://ik.imagekit.io/anehqc9js/tr:n-' + preset + '/' + cleanPath;
  }

  return apiCdn + '/' + cleanPath;
};


// WEBPACK FOOTER //
// ./src/app/utils/getCDNUrl.js